// import React from 'react';
import React, { useState, useEffect, useContext } from 'react';
import { ethers } from 'ethers';
import $ from 'jquery';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
// import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
// import MenuItem from '@mui/material/MenuItem';
// import AdbIcon from '@mui/icons-material/Adb';

import { BrowserRouter, Route, Link } from "react-router-dom";

import { resetConnection1 } from './pages/Create';
import { resetConnection2 } from './pages/Project';
import { resetConnection3 } from './pages/Browse';

// Web3-Onboard
	import Onboard from '@web3-onboard/core';
	import { switchChain } from '@web3-onboard/core';
	import injectedModule from '@web3-onboard/injected-wallets';

import { ThemeProvider, createTheme, rgbToHex } from '@mui/material/styles';
import './index.css';

// Set base URLs & IDs
    // let WEB3_ONBOARD_ID, PSISCOPE_ICON, NETWORK_CHAIN_ID;

    // if (process.env.NODE_ENV === "development") {
    //     console.log("local environment");
    //     WEB3_ONBOARD_ID = process.env.REACT_APP_WEB3_ONBOARD_ID_LOCAL;
    //     PSISCOPE_ICON = process.env.REACT_APP_PSISCOPE_ICON_LOCAL;
    //     NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;      
    // } else {
    //     console.log("production environment");
    //     WEB3_ONBOARD_ID = process.env.REACT_APP_WEB3_ONBOARD_ID_PRODUCTION;
    //     PSISCOPE_ICON = process.env.REACT_APP_PSISCOPE_ICON_PRODUCTION;
    //     NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;  
    // }

	let WEB3_ONBOARD_ID, PSISCOPE_ICON, USER_API_ENDPOINT_ROOT, TEAMS_API_ENDPOINT_ROOT, API_ENDPOINT_ROOT, PROVIDER_URL, INFURA_ETHEREUM_URL, ASSETS_FOLDER, NETWORK_CHAIN_ID;

	if (process.env.NODE_ENV === "development") {
		console.log("local environment");
		// WEB3_ONBOARD_ID = process.env.REACT_APP_WEB3_ONBOARD_ID_LOCAL;
		PSISCOPE_ICON = process.env.REACT_APP_PSISCOPE_ICON_LOCAL;

		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_LOCAL;
		TEAMS_API_ENDPOINT_ROOT = process.env.REACT_APP_TEAMS_API_ENDPOINT_ROOT_LOCAL;
		API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_LOCAL;
		PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_LOCAL;
		// INFURA_ETHEREUM_URL = process.env.REACT_APP_INFURA_ETHEREUM_URL_LOCAL;
		ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_LOCAL;
		NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;      
	} else {
		console.log("production environment");
		// WEB3_ONBOARD_ID = process.env.REACT_APP_WEB3_ONBOARD_ID_PRODUCTION;
		PSISCOPE_ICON = process.env.REACT_APP_PSISCOPE_ICON_PRODUCTION;

		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_PRODUCTION;
		TEAMS_API_ENDPOINT_ROOT = process.env.REACT_APP_TEAMS_API_ENDPOINT_ROOT_PRODUCTION;
		API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_PRODUCTION;
		PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_PRODUCTION;
		// INFURA_ETHEREUM_URL = process.env.REACT_APP_INFURA_ETHEREUM_URL_PRODUCTION;
		ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_PRODUCTION;
		NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;
	}


export function switchNavConnectButtonText(account) {
    if (account != "CONNECT (BLOCKCHAIN)") {
		const accountTruncated = account.slice(0, 6) + '...' + account.slice(-4);
		$('#connect-btn-big').html(accountTruncated);
		const accountTruncated2 = account.slice(0, 5) + '...' + account.slice(-4);
		$('#connect-btn-small').html(accountTruncated2);
    } else {
		$('#connect-btn-big').html("CONNECT (BLOCKCHAIN)");
		$('#connect-btn-small').html("CONNECT");
    }
}

export async function getPageName(_lastChars = 3) {
	// Full URL
		const currentURL = window.location.href;
	// Cut off all parameters from URL
		const currentURL_noParams = currentURL.split('?')[0];
	// Get just the last 3 characters
		const lastChars = 0 - _lastChars;
		const pageId = currentURL_noParams.slice(lastChars);
	console.log("Page id: " + pageId);
	return pageId.toLowerCase();
}

// Manage Page Reload or Reset (used when connecting to wallet, switching wallet account or chain, etc.)
async function reloadOrReset(_mode = null) {
	console.log("reloadOrReset triggered");
	const pageId = await getPageName(4);
	console.log("Page id: " + pageId);
	if (pageId == "eate"|| pageId == "ate/" || pageId == "3001" || pageId == "001/") { // if on 'Create' page
		console.log("resetConnection1 should be triggered on Create page: " + pageId);
		// resetConnection1();
		if (_mode == 'skip wallet prompt') {
			resetConnection1('skip wallet prompt');
		} else {
			resetConnection1();
		}
	} else if (pageId == "ject"|| pageId == "ect/") { // If on 'Project' page
		console.log("resetConnection2 should be triggered on Project page: " + pageId);
		if (_mode == 'skip wallet prompt') {
			resetConnection2('skip wallet prompt');
		} else {
			resetConnection2();
		}
	} else { // If on 'Browse' page
		console.log("Page should reload");
		window.location.reload();
	}
}

// Main blockchain button switching
	export function mainButtonSwitcher(show) {
		console.log("Main button switcher triggered. 'Show' = " + show);
		setTimeout(function() {
			$(".bchain-button").hide();
			$(".connect-wallet-button").hide();
			$(".switch-chain-button").hide();
			$(".bchain-help-section").hide();
			if (show == "bchain") { $(".bchain-button").show(); }
			if (show == "connect") { $(".connect-wallet-button").show(); }
			if (show == "switch") { $(".switch-chain-button").show(); }
			if (show != "bchain") { $(".bchain-help-section").show(150); }

		}, 1000); // delay of 1 sec
	}

	export async function bchainCheckAndButtonControl(_mode = null) {

		console.log("= = = = bchainCheckAndButtonControl triggered = = = = ... _mode: " + _mode);

		const connectionStatus = await checkWalletStatus(); // Returned values (object) - walletInstalled, walletConnected, walletAccount, correctChain, allSet

		// Check if wallet is installed
		if (connectionStatus.walletInstalled == true) {
			console.log("Wallet installed");
		} else {
			switchNavConnectButtonText("CONNECT (BLOCKCHAIN)");
			mainButtonSwitcher('connect');
		}

		// Check if app is connected to wallet
		if (connectionStatus.walletConnected == true) { // If connected...
			console.log("User connected to wallet");

			// setUserAddress(connectionStatus.walletAccount);
			switchNavConnectButtonText(connectionStatus.walletAccount);

			if (_mode !== 'skip wallet prompt' && _mode !== 'on load') {
				// = = = = = Call connectWallet = = = =
				console.log("- - - - Call connectWallet");
				await connectWallet(); // * * * * *
				reloadOrReset('skip wallet prompt'); // triggers setupBlockchain
			}

			// Check chain ID
				if (connectionStatus.correctChain == true) {
					console.log("Correct chain");
					buttonSelectionFilter('bchain');
				} else {
					console.log("Incorrect chain");
					buttonSelectionFilter('switch');
				}

			// Function to filter button selection
				function buttonSelectionFilter(_mode2) {
					// If on page load, display 'connect' button in all cases
					if (_mode == 'on load') {
						console.log("'On load' mode - call mainButtonSwitcher('connect')");
						mainButtonSwitcher('connect');
						switchNavConnectButtonText("CONNECT (BLOCKCHAIN)");
					} else {
						if (_mode2 == 'bchain') {
							console.log("Call mainButtonSwitcher('bchain')");
							mainButtonSwitcher('bchain');
						} else if (_mode2 == 'switch') {
							console.log("Call mainButtonSwitcher('switch')");
							mainButtonSwitcher('switch');
						}
					}
				}

			await listenForAccountChanges();
			await listenForChainChanges();

		} else { // If user is not connected to wallet...
			console.log("User not connected to wallet");
			console.log("Change button text");
			switchNavConnectButtonText("CONNECT (BLOCKCHAIN)");
			mainButtonSwitcher('connect');
		}
	}

// Check blockchain connection
	export async function checkWalletStatus() {

		console.log("checkWalletStatus triggered");
		let walletInstalled = false; let walletConnected = false; let correctChain = false; let allSet = false; let walletAccount = null;
		// Check if wallet is installed

		if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
			// console.log("Wallet is installed");
			walletInstalled = true;

			// Load wallet account & check if user is connected
				const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
				walletAccount = wallet_accounts[0];
				console.log("blockchain account: " + walletAccount);

				if (walletAccount) { 
					walletConnected = true;

					// Check chain ID
						let chainID = await window.ethereum.request({ method: 'eth_chainId' });
						console.log('Chain ID: ' + chainID);

						if (chainID != NETWORK_CHAIN_ID) {
							// console.log("Wrong chain");
							correctChain = false;
							allSet = false;
						} else {
							// console.log("User is all set");
							correctChain = true;
							allSet = true;
							// sendButtonDisabled = false; // ???
						}
				} else {
					// console.log("Blockchain account not connected to app");
					walletConnected = false;
					allSet = false;
				}
		} else {
			console.log("Wallet is not available");
			allSet = false;
		}

		// Console log results as an object
			console.log("Check wallet status: ", { walletInstalled: walletInstalled, walletConnected: walletConnected, walletAccount: walletAccount, correctChain: correctChain, allSet: allSet });

		return { walletInstalled: walletInstalled, walletConnected: walletConnected, walletAccount: walletAccount, correctChain: correctChain, allSet: allSet };
	}


// Set up blockchaion connection

	// export async function setupBlockchainConnection(pageName, previous_wallet = false) {

	// 	console.log("setupBlockchainConnection triggered");
	// 	let connected = false, wrongChain = false;

	// 	// Check if wallet is installed
	// 	if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 

	// 		console.log("Wallet is installed");

	// 		// Load account & check if user is connected
	// 		const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
	// 		const account = wallet_accounts[0];
	// 		console.log("Detected wallet account: " + account);
	// 		console.log('listenForAccountChanges triggered');
	// 		await listenForAccountChanges();

	// 		if (typeof account !== "undefined") { 
	// 			console.log("User account active: " + account);
	// 			switchNavConnectButtonText(account);
				
	// 			// Check chain ID
	// 				let chainID = await window.ethereum.request({ method: 'eth_chainId' });
	// 				console.log('Chain ID: ' + chainID);
	// 			// Monitor chain change
	// 				console.log("Listen for chain changes - 1");
	// 				await listenForChainChanges();

	// 				if (chainID != NETWORK_CHAIN_ID) { // Switch chain if needed...
	// 					console.log("Wrong chain");
	// 					wrongChain = true;
	// 					connected = false;
	// 					mainButtonSwitcher('switch');
	// 				} else {
	// 					console.log("User is all set");
	// 					connected = true;
	// 					sendButtonDisabled = false;
	// 					mainButtonSwitcher('bchain');
	// 				}
	// 			// Get team list for SEARCH if on Create page
	// 				// if (pageName == 'ate' || pageName == 'te/' || pageName == '00/' || pageName == '000' || pageName == '001' || pageName == '01/' || pageName == '002' || pageName == '002/') {
	// 				// 	await getDataForSearchList('owner_address');
	// 				// }

	// 		} else {
	// 			console.log("User is not connected");
	// 			connected = false;
	// 			switchNavConnectButtonText("CONNECT (BLOCKCHAIN)");
	// 			mainButtonSwitcher('connect');
	// 		}

	// 	} else {
	// 		console.log("Wallet is not available");
	// 		connected = false;
	// 		switchNavConnectButtonText("CONNECT (BLOCKCHAIN)");
	// 		mainButtonSwitcher('connect');
	// 	}

	// 	console.log("User connected?: " + connected);

	// 	// If user doesn't have a wallet, is not connected to a wallet, or is connected to a wrong chain, set Alchemy as provider
	// 		if (connected == false) {
	// 			console.log("Use Alchemy as provider");
	// 			let provider = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
	// 			getContract(provider);
	// 		}
	// 	// If user has a wallet, is connected to a wallet, and is connected to the right chain, set wallet as primary blockchain provider, and Alchemy as secondary provider
	// 		if (connected == true) {
	// 			console.log("Use wallet as provider");
	// 			let provider = new ethers.providers.Web3Provider(window.ethereum);
	// 			let providerRpc = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
	// 			getContract(provider, providerRpc);
	// 		}
	// 	// Check if user has a previously connected wallet, handle accordingly
	// 		if (previous_wallet == 'no-previous' && (connected == true || wrongChain == true )) {
	// 			console.log('Need to activate Web3-Onboard');
	// 			mainButtonSwitcher('connect');
	// 		}

	// 	return connected;
	// }


// Switch to correct chain 
	// export async function switchToCorrectChain() {
	// 	try {
	// 		console.log("Try switching network/chain");
	// 		await window.ethereum.request({
	// 			method: 'wallet_switchEthereumChain',
	// 			params: [{ chainId: NETWORK_CHAIN_ID }],
	// 		})
	// 		return "success";
	// 	} catch(err) {
	// 		return err;
	// 		if (err.code === 4902) { // if network not found, add it
	// 			connectWallet(); // imported from navbar
	// 		} else {
	// 			alert("Could not swtich network!")
	// 			$(".bchain-button").hide();
	// 			$(".connect-wallet-button").show();
	// 			$(".switch-chain-button").hide();
	// 		}
	// 	}
	// }


// Web3 Onboard 

    const injected = injectedModule()

    const onboard = Onboard({
		wallets: [injected],
		chains: [
			{
				id: '0x1',
				token: 'ETH',
				label: 'Ethereum',
				rpcUrl: 'https://mainnet.infura.io/v3/${INFURA_ID}'
				// rpcUrl: '${INFURA_ETHEREUM_URL}'
			},
			{
				id: '0x89',
				token: 'POL',
				label: 'Polygon Mainnet',
				// rpcUrl:'https://rpc.ankr.com/polygon',
				rpcUrl:'https://polygon-rpc.com',
				// rpcUrl: 'https://rpc-mainnet.maticvigil.com',
				blockExplorerUrl: 'https://polygonscan.com'
			},
			{
				id: '0x2105', // '8453'
				token: 'ETH',
				label: 'Base Mainnet',
				rpcUrl:'https://base-rpc.publicnode.com',
				// rpcUrl:'https://mainnet.base.org',
				blockExplorerUrl: 'https://basescan.org/'
			}
			// {
			// 	id: '0x13881',
			// 	token: 'MATIC',
			// 	label: 'Mumbai testnet',
			// 	rpcUrl: 'https://rpc-mumbai.maticvigil.com',
			// 	blockExplorerUrl: 'https://mumbai.polygonscan.com'
			// }
			// {
			// 	id: '0x7a69',
			// 	token: 'LOCAL',
			// 	label: 'Hardhat'
			// }
		],
		accountCenter: {
			desktop: {
				position: 'topRight',
				enabled: true,
				minimal: false
			},
			mobile: {
				position: 'bottomRight',
				enabled: true,
				minimal: true
			}
		},
		appMetadata: {
			name: 'Psiscope',
			icon: PSISCOPE_ICON,
			// logo: myLogo, // svg string logo
			description: 'Psi + blockchain = reality revolution',
			recommendedInjectedWallets: [
				{ name: 'MetaMask', url: 'https://metamask.io' },
				{ name: 'Coinbase', url: 'https://wallet.coinbase.com/' }
			]
		},
		// apiKey: WEB3_ONBOARD_ID, // added
		notify: { // added
			desktop: {
				enabled: true,
				transactionHandler: transaction => {
					console.log({ transaction })
					if (transaction.eventCode === 'txPool') {
					return {
						type: 'success',
						message: 'Your transaction is in progress',
					}
					}
				},
				position: 'topRight'
			},
			mobile: {
				enabled: true,
				transactionHandler: transaction => {
					console.log({ transaction })
					if (transaction.eventCode === 'txPool') {
					return {
						type: 'success',
						message: 'Your transaction is in progress',
					}
					}
				},
				position: 'topRight'
			}
		}
    })


// functions for Web3 Onboard

	// Subscsribe for auto-selecting wallet when user returns
	export async function subscribeToWallets() {
		
		// console.log("subscribeToWallets triggered");
		// await clearConnectedWallets(); // testing 1/7/25
		// const walletsSub = onboard.state.select('wallets');
		// const { unsubscribe } = walletsSub.subscribe((wallets) => {
		// 	console.log("Check Connected wallets 444");
		// 	const connectedWallets = wallets.map(({ label }) => label);
		// 	console.log("Check Connected wallets 555: ", connectedWallets);
		// 	window.localStorage.setItem('connectedWallets', JSON.stringify(connectedWallets));
		// })
	}

	export async function clearConnectedWallets() { // May not work
		console.log("Clearing connected wallets from localStorage");
		window.localStorage.removeItem('connectedWallets');
	}

	export async function getActiveWalletName() {
		const activeWallet= onboard.state.get().wallets;
		console.log("Active wallet: ", activeWallet[0].name);
		return activeWallet[0].name;
	}

	const resetWeb3Onboard = async () => {
		const wallets_ = onboard.state.get().wallets;
	
		for (const wallet_ of wallets_) {
			await onboard.disconnectWallet({ label: wallet_.label });
		}
		console.log('All wallets disconnected. Web3-Onboard state reset.');
	};



	// Monitor wallet account changes
		export async function listenForAccountChanges() {
			console.log("- - - ListenForAccountChanges triggered");
			// Check if wallet is installed
			if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
				console.log("Wallet is installed - listner");
				// Load account & check if user is connected
					const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
					console.log('wallet_accounts[0]: ' + wallet_accounts[0]);

					if (typeof wallet_accounts[0] !== "undefined") { 
						console.log("User account active - listner: " + wallet_accounts[0]);
						// Remove account change listner
							console.log("Remove ALL wallet account change listners");
							window.ethereum.removeAllListeners('accountsChanged');
						// Set listner for account changes
							console.log("Listen for wallet account changes - 1");
							window.ethereum.on('accountsChanged', function (wallet_accounts) {
								console.log("Account change detected - 1");
								resetWalletConnection('account change'); // added 1/26/25
								// reloadOrReset();
							})
					}
			}
		}

	// Monitor chain changes
		export async function listenForChainChanges() {
			console.log("- - - ListenForChainChanges triggered ");
			setTimeout(function() {
			// Remove chain change listner
				console.log("Remove ALL chain change listners - 0");
				window.ethereum.removeAllListeners('chainChanged');
			// Monitor chain change
				console.log("Chain change listener set- 0");
				window.ethereum.on('chainChanged', onChainChanged);
			}, 1000); // delay of 1 sec
		}
		async function onChainChanged(chainId) {
			console.log("= = = = Chain change detected - 0");
			// await resetWalletConnection('chain change'); // added 1/20/25
			// added 7/3/25
				await bchainCheckAndButtonControl('skip wallet prompt'); 
				// Below disabled to avoid wallet prompt (7/3/25)
					// await resetWeb3Onboard();
					// const connectedWallet = await onboard.connectWallet();
				await refreshAccountCenterWithoutPrompt(onboard); // new 7/3/25
		}


	async function refreshAccountCenterWithoutPrompt(onboard) {
		const [wallet] = onboard.state.get().wallets
		if (!wallet) return

		// Disconnect the wallet without triggering UI
		await onboard.disconnectWallet({ label: wallet.label })

		// Reconnect silently without showing modal
		await onboard.connectWallet({
			autoSelect: {
				label: wallet.label,
				disableModals: true
			}
		})
	}


	// Reset Web3 Onboard and reconnect (added 1/20/25) * * * *
		const resetWalletConnection = async (_mode) => {
			console.log("resetWalletConnection triggered with");
			// Simply resetting connection switches to new chain (on chain changed)
			// await resetWeb3Onboard(); 
			await connectWallet(); 
			if (_mode = 'account change') {
				reloadOrReset('skip wallet prompt');
			}
		};
		
	// Connect wallet
	export async function connectWallet(_mode = null) {
		console.log("= = = = connectWallet called = = = = =");
		console.log('mode check: ' + _mode);

		if (_mode !== 'noreset') {
			console.log('Reset Web3Onboard');
			await resetWeb3Onboard(); // new 7/1/25
		}

		try {
			const connectedWallet = await onboard.connectWallet();
			if (connectedWallet.length > 0) {
				console.log("Wallet connected:", connectedWallet);
				// await subscribeToWallets(); // added 1/4/25
				// switchNetwork(); // Disabled 1/12/25
				await bchainCheckAndButtonControl('skip wallet prompt');

				// If coming from navbar 'Connect' button on Browse page (doing the same thing as handleMainBlockchainButton on Browse page)
					const pageId = await getPageName(4);
					console.log("Page id: " + pageId);
					if (pageId == "owse"|| pageId == "wse/") { 
						await switchNetwork();
						await resetConnection3();
					}

			} else {
				console.log("No wallet connected");
			}
		} catch (error) {
			console.error("Error connecting wallet:", error);
		}
	}

	export async function switchNetwork() { // Switch to correct chain
		console.log("switchNetwork called");
		let switchResult = 'correct';

		const connectionStatus = await checkWalletStatus();
		// console.log("Connection status: ", connectionStatus);
		if (connectionStatus.correctChain !== true) { // if wrong chain...
			console.log("Switching network...");

			try { // New method added here 1/17/25
				console.log("Try switching network/chain");
				await window.ethereum.request({
					method: 'wallet_switchEthereumChain',
					params: [{ chainId: NETWORK_CHAIN_ID }],
				})
				switchResult = 'switched';
				console.log("switchResult: " + switchResult);

			} catch(err) {
				console.log('err.code: ' + err.code)
				if (err.code === 4902) { // if network not found, add it
					// connectWallet(); // imported from navbar
					// // New 7/1/25:
						 const networkSwitched = await onboard.setChain({ chainId: NETWORK_CHAIN_ID });
						 if (networkSwitched == true) {
							switchResult = 'added';
						 } else {
							switchResult = 'error';
						 }
						console.log("switchResult: " + switchResult);
				} else {
					console.log("Error switching network: ", err);
					alert("Could not switch network!")
					reloadOrReset('skip wallet prompt');
					// switchResult = 'error';
				}
			}
		} 
		return switchResult; // 'correct', 'switched', 'added' or 'error' - not being used but JIC
	}


	// async function handleNavbarConnectClick() { // Needed before calling "connectWallet" to handle wallet connect click from "Browse" page's navbar which needs to be processed differently
	// 	console.log("handleNavbarConnectClick")
	// 	const pageName = getPageName();
	// 	if (pageName == 'wse') {
	// 		console.log("Wallet Connect navbar click from Browse page")
	// 		const wallets = await onboard.connectWallet();
	// 		const networkSwitch = await onboard.setChain({ chainId: NETWORK_CHAIN_ID });
	// 		console.log("Network switch?: " + networkSwitch);
	// 		window.location.reload(); // This is what's uniquely needed for Browse page
	// 	} else {
	// 		console.log("Call connectWallet")
	// 		connectWallet();
	// 	}
	// }

// Auto-selsect wallet

	// Subscsribe for auto-selecting wallet when user returns
		// export async function subscribeToWallets() {

		// 	console.log("subscribeToWallets triggered");
		// 	const walletsSub = onboard.state.select('wallets')
		// 	const { unsubscribe } = walletsSub.subscribe((wallets) => {
		// 		const connectedWallets = wallets.map(({ label }) => label)
		// 		window.localStorage.setItem('connectedWallets', JSON.stringify(connectedWallets));
		// 	})
		// }

	// Get 'connectedWallets' from local storage
		export async function getPreviousWallets() {
			const previousWallets = JSON.parse(window.localStorage.getItem('connectedWallets'));
			console.log("Check previousWallets: ", previousWallets); // null OR empty array
			return previousWallets;
		}

	// Check if there is a previously connected wallet
		export async function checkPreviousWalletExists() {

			console.log("checkPreviousWalletExists triggered");
			const previousWallets = await getPreviousWallets();
			console.log("Previous wallets: ", previousWallets);

			let previousWalletExists = true
			if (!previousWallets) { 
				console.log('Previous wallet missing - 1');
				previousWalletExists = false;
			} else {
				if (previousWallets.length == 0) {
					console.log('Previous wallet missing - 2');
					previousWalletExists = false;
				} else {
					console.log('Previous wallet exists');
					previousWalletExists = true;
				}
			}

			return previousWalletExists;
		}


	// Auto-select previously used wallet
	// Whole sequence STARTS HERE on page load * * * * *
		export async function autoSelectWallet() {
			console.log("wallet auto select triggered [...IGNORED]");

			// if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { // If wallet is installed...

			// 	const previousWalletExists = await checkPreviousWalletExists();
			// 	console.log("Previous wallet exists?: ", previousWalletExists);

			// 	if (previousWalletExists == true) {
			// 		// Get previously connected wallets
			// 			const previouslyConnectedWallets = await getPreviousWallets();
			// 			console.log("Previously connected wallets: ", previouslyConnectedWallets);
						
			// 		// Connect most recently connected wallet (first in array)
			// 			console.log("Auto-selecting previously connected wallet");

			// 			let autoConnected;
			// 			try {
			// 				 autoConnected = await onboard.connectWallet({ autoSelect: previouslyConnectedWallets[0] });

			// 				// autoConnected = await onboard.connectWallet({ autoSelect: { label: previouslyConnectedWallets[0], disableModals: true } });

			// 				// if (autoConnected) {
			// 				// 	if (autoConnected.length > 0) {
			// 				// 		console.log("Auto-connected to: ", autoConnected[0]);
			// 				// 	}
			// 				// } else {
			// 				// 	console.log("No wallet connected");
			// 				// }


			// 			} catch(err) {
			// 				console.log("Error: ", err);
			// 			}

			// 			console.log("Auto-connected?: ", autoConnected);

			// 			if (autoConnected.length == 0) { // If no wallet connected...
			// 				console.log("Need to connect to wallet not previously connected");
			// 				await connectWallet();
			// 			}

			// 			switchNetwork();
			// 	} else {
			// 		console.log("No previous wallet detected");
			// 		await connectWallet(); // added (12/25/24)
			// 		// await subscribeToWallets(); // added (12/19/24)
			// 	}

			// } else {
			// 	console.log("No wallet detected - 0");
			// 	// checkPageNameForBlockchain(pageName, 'no-previous'); 
			// 	// return false;
			// }
		}

    
// Check if wallet is installed. If so, trigger autoSelectWallet; if not, trigger checkPageNameForBlockchain [ * * SEQUENCE STARTS HERE * * ]

	// export async function checkWalletAndAutoSelect() {

	// 	if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
	// 		console.log("Wallet is installed - 0");
	// 		autoSelectWallet(); // Function triggered * * *
	// 	} else {
	// 		console.log("No wallet detected - 0");
	// 		const pageName = getPageName(); // Function triggered * * *
	// 		checkPageNameForBlockchain(pageName, 'no-previous'); // Function * * *
	// 	}
	// }


// - - - - - - - - - - - - - - 

function ResponsiveAppBar() {

	const [anchorElNav, setAnchorElNav] = useState(null);
	const [anchorElUser, setAnchorElUser] = useState(null);

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};
	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseNavMenu = () => {
		setAnchorElNav(null);
	};
	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};


	useEffect(() => { //  * * Triggered on page load * * 
		//
	}, []);

	// Set dark theme
		const darkTheme = createTheme({
			palette: {
				mode: 'dark',
				// primary: deepOrange,
				// divider: deepOrange[700],
				background: {
				// default: deepOrange[900],
				// paper: grey[900],
				paper: '#1f242e',
				},
				text: {
				// primary: '#fff',
				// secondary: grey[500],
				},
			},
		});
  

	return (

		<ThemeProvider theme={darkTheme}>

		<AppBar position="static">
		<Container maxWidth="xl">
			<Toolbar disableGutters>

			{/* Desktop */}
				<img id="psiscope-logo-nav-left" src={PSISCOPE_ICON} />
				{/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
				<Typography
				variant="h6"
				noWrap
				component="a"
				href="/"
				sx={{
					mr: 2,
					display: { xs: 'none', md: 'flex' },
					fontFamily: 'monospace',
					fontWeight: 700,
					letterSpacing: '.3rem',
					color: 'inherit',
					textDecoration: 'none',
				}}
				>
				PSISCOPE
				</Typography>

			{/* Mobile */}
				<Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

				<IconButton
					size="large"
					aria-label="account of current user"
					aria-controls="menu-appbar"
					aria-haspopup="true"
					onClick={handleOpenNavMenu}
					color="inherit"
				>
					<MenuIcon />
				</IconButton>
				<Menu
					id="menu-appbar"
					anchorEl={anchorElNav}
					anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
					}}
					keepMounted
					transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
					}}
					open={Boolean(anchorElNav)}
					onClose={handleCloseNavMenu}
					sx={{
					display: { xs: 'block', md: 'none' },
					}}
				>
					<Button sx={{ my: 2, color: 'white', display: 'block' }} >
						<Link className="nav-menu-mobile" to="/create">
						Create</Link>
					</Button>
					<Button sx={{ my: 2, color: 'white', marginTop: '-12px', marginLeft: '0px', marginRight: '5px', display: 'block' }} >
						<Link className="nav-menu-mobile" to="/browse">
						Browse</Link>
					</Button>
					<Button sx={{ my: 2, color: 'white', marginTop: '-12px', marginLeft: '0px', marginRight: '5px', display: 'block' }} >
						<Link className="nav-menu-mobile" to="/faq">
						FAQ</Link>
					</Button>
					
					<Button sx={{ my: 2, color: 'white', marginTop: '-12px', marginLeft: '0px', marginRight: '5px', display: 'block' }} onClick={connectWallet} >
						Connnect
					</Button>

				</Menu>
				</Box>

				<img id="psiscope-logo-nav-center" src={PSISCOPE_ICON} style={{display: 'none'}} />
				{/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
				<Typography
				variant="h5"
				noWrap
				component="a"
				href="/"
				sx={{
					mr: 2,
					display: { xs: 'flex', md: 'none' },
					flexGrow: 1,
					fontFamily: 'monospace',
					fontWeight: 700,
					letterSpacing: '.3rem',
					color: 'inherit',
					textDecoration: 'none',
				}}
				>
					PSISCOPE
				</Typography>

			{/* Desktop */}
				<Box sx={{ flexGrow: 1, display: { border:'0px solid red', xs: 'none', md: 'flex', alignItems:'center' }, justifyContent:'center' }}>

					<Typography variant="body1" display={{border: '0px solid red'}} style={{ margin: '0px 13px 0px -7px', fontSize:'15px', color: 'rgb(173, 173, 173)' }}>
						THIS APP:
					</Typography>

					<Button sx={{ my: 2, color: 'white', display: 'block' }} >
						<Link className="navbar" to="/create" style={{ fontSize:'15px', color:'rgb(232, 232, 232)' }}>Create</Link>
					</Button>
					<Button sx={{ my: 2, color: 'white', display: 'block' }} >
						<Link className="navbar" to="/browse" style={{ fontSize:'15px', color:'rgb(232, 232, 232)' }}>Browse</Link>
					</Button>
					<Button sx={{ my: 2, color: 'white', display: 'block' }} >
						<Link className="navbar" to="/faq" style={{ fontSize:'15px', color:'rgb(232, 232, 232)' }}>FAQ</Link>
					</Button>

				</Box>


			{/* Connect Wallet */}

			<Box sx={{ flexGrow: 0, marginLeft:'auto' }}>

				<Button id="connect-btn-big" variant="outlined" style={{minWidth:'165px', fontWeight: "bold"}} onClick={connectWallet} >
					Connect (Blockchain)
				</Button>
				<Button id="connect-btn-small" variant="outlined" style={{ display: "none"}} onClick={connectWallet} >
					Connect
				</Button>

			</Box>

			</Toolbar>
		</Container>
		</AppBar>

		</ThemeProvider>

	);
}

export default ResponsiveAppBar;